// extracted by mini-css-extract-plugin
export default {"root":"WireInstructionsAddEditContent_root__dW-Y2","spanTwo":"WireInstructionsAddEditContent_spanTwo__fZvRb","furtherCredit":"WireInstructionsAddEditContent_furtherCredit__GojSu"};